<template>
  <div class="bclist">
      <div class="vh-70 scroll">
        <b-list-group flush>
          <b-list-group-item v-for="bc in businessCasesOfDialog" :key="bc.id">
            <b-badge :variant="setVariant(bc)" pill class="mr-2">{{bc.status}}</b-badge>
            <b-link v-if="bc.status=='ACTIVE'" @click="$emit('jumpToBC', bc)">{{bc.name}}</b-link>
            <span v-else>{{bc.name}}</span>

            <b-badge variant="light" pill>{{bc.category}}</b-badge>

            <b-link @click="complete(bc)" title="complete">
              <b-icon v-if="bc.status=='ACTIVE'" variant="success" icon="check-circle" font-scale="1.5" class="float-right"></b-icon>
            </b-link>

            <b-link @click="cancel(bc)" title="cancel">
              <b-icon v-if="bc.status=='ACTIVE'" variant="danger"  icon="x-circle" font-scale="1.5" class="float-right" ></b-icon>
            </b-link>

            <b-link @click="reject(bc)" title="reject" >
              <b-icon v-if="bc.status=='CANDIDATE'" variant="secondary" icon="x-circle" font-scale="1.5" class="float-right" ></b-icon>
            </b-link>

            <b-link @click="activate(bc)" title="activate" >
              <b-icon v-if="bc.status=='CANDIDATE' || bc.status=='CANCELLED' || bc.status=='REJECTED' || bc.status=='COMPLETED'" variant="success" icon="circle" font-scale="1.5" class="float-right"></b-icon>
            </b-link>
          </b-list-group-item>
        </b-list-group>
      </div>
  </div>
</template>

<script>

export default {
  name: 'DialogBusinessCases',
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    activate(bc) {
      this.$store.dispatch('setBusinessCaseStatusInDialogue', { 'dialogId': this.dialog.dialogueId, 'businessCaseId': bc.id , 'status': 'ACTIVE'});
    },
    reject(bc) {
      this.$store.dispatch('setBusinessCaseStatusInDialogue', { 'dialogId': this.dialog.dialogueId, 'businessCaseId': bc.id , 'status': 'REJECTED'});
    },
    cancel(bc) {
      this.$store.dispatch('setBusinessCaseStatusInDialogue', { 'dialogId': this.dialog.dialogueId, 'businessCaseId': bc.id , 'status': 'CANCELLED'});
    },
    complete(bc) {
      this.$store.dispatch('setBusinessCaseStatusInDialogue', { 'dialogId': this.dialog.dialogueId, 'businessCaseId': bc.id , 'status': 'COMPLETED'});
    },
    setVariant(bc) {
      if(bc.status == "ACTIVE") return 'warning';
      if(bc.status == "CANCELLED") return 'danger';
      if(bc.status == "COMPLETED") return 'success';
      if(bc.status == "REJECTED") return 'light';
      if(bc.status == "CANDIDATE") return 'secondary';
    }
  },
  computed: {
    businessCasesOfDialog () {
      if( this.$store.state.businessCasesOfDialog ) {
        return this.$store.state.businessCasesOfDialog;
      } else {
        return null;
      }
    },
    dialog () {
      return this.$store.state.dialog;
    },
  }
}
</script>

<style scoped>

</style>
